import { createFileRoute } from "@tanstack/react-router";
import ITPGuide from "@/pages/ghiduri/ITPGuide";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/ghiduri/itp-inspectia-tehnica-periodica/")({
  head: () => routeHead("/ghiduri/itp-inspectia-tehnica-periodica/"),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <ITPGuide />
  );
}
